/* eslint-disable react/prop-types */
import React from 'react';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TabTitle = ({ title, value, percentage, progress }) => (
  <div className="p-2 pe-4 text-start cursor-pointer">
    {title && <h6 className="text-800 fs--2 text-nowrap">{title}</h6>}
    {value && <h5 className="text-800">{value}</h5>}
    {percentage && (
      <Flex alignItems="center">
        <FontAwesomeIcon
          icon={progress ? 'caret-up' : 'caret-down'}
          className={progress ? 'text-success' : 'text-warning'}
        />
        <h6
          className={`fs--2 mb-0 ms-2 ${
            progress ? 'text-success' : 'text-warning'
          }`}
        >
          {percentage}
        </h6>
      </Flex>
    )}
  </div>
);

export default TabTitle;
